import {SoopButtonCircle, SoopSkeleton} from '@soop-ui/soop-ui';
import clsx from 'clsx';
import styles from './ProfileMessage.module.scss';
import layerStyles from '../ChannelInfo/InfoLayer/InfoLayer.module.scss';
import {useStationData} from '@/stores/channel/station';
import {ReactTyped} from 'react-typed';
import {useState} from 'react';
import useChannelClickLog from '@/hooks/channel/useChannelClickLog';

const ProfileMessage = ({
  className,
  loading,
}: {
  className?: string;
  loading?: boolean;
}) => {
  const {station} = useStationData();
  const {display} = station;

  const {sendClickLog} = useChannelClickLog();

  const [isAiMessage, setIsAiMessage] = useState(
    display?.aiProfileConfYn === 'Y',
  );

  const handleChangeAiMessage = async () => {
    setIsAiMessage((prev) => !prev);

    await sendClickLog('station_click', {
      button_group: 'station_info',
      button_type: 'introduce',
      action_type: !isAiMessage ? 'ai_introduce' : 'profile_messege',
    });
  };

  return (
    <div
      className={clsx(
        styles.profileMessageWrapper,
        layerStyles.messageWrapper,
        className,
      )}>
      {loading ? (
        <SoopSkeleton width={352} height={22} animated />
      ) : (
        <>
          <div className={styles.messageWrap}>
            {!isAiMessage ? (
              <>
                {/* 프로필 메세지 */}
                <p className={styles.message}>{display?.profileText}</p>
              </>
            ) : (
              <>
                <p className={styles.message}>{display?.aiProfileStr}</p>
              </>
            )}
          </div>
          {/* ai 소개 우선 노출 대상이 아니면 스위칭 버튼 미노출 */}
          {display?.aiProfileConfYn !== 'N' && (
            <SoopButtonCircle
              className={styles.btnNote}
              iconName='icoChange'
              size={20}
              variant='linePrimary'
              onClick={handleChangeAiMessage}
            />
          )}
        </>
      )}
    </div>
  );
};

export default ProfileMessage;
